import styled from 'styled-components'
import { Dialog, DialogContent } from '@material-ui/core'

// One-time Kehila -> Protocols migration wizard - temporary, will be removed after the migration.

export const colors = {
  ink: '#12181c',
  ink2: '#4a565e',
  ink3: '#7d8a92',
  paper: '#f2f4f4',
  card: '#ffffff',
  line: '#dbe1e2',
  line2: '#c2cbcd',
  signal: '#0d6b76',
  signalBg: '#e2eff0',
  ok: '#1c6e45',
  okBg: '#e3f0e8',
  bad: '#a52a20',
  badBg: '#fbe8e5',
}

export const WizardDialog = styled(Dialog)`
  .MuiDialog-paperWidthMd {
    width: 1040px;
    /* Stay inside the viewport when it is narrower than 1040px (small screens
       or high browser zoom) instead of overflowing horizontally. */
    max-width: calc(100vw - 64px);
  }
`

export const WizardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
  background: rgba(0, 126, 255, 0.2);
  color: ${colors.ink};

  .MuiIconButton-root {
    color: ${colors.ink};
    padding: 6px;
  }
`

export const WizardTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
`

export const WizardBody = styled(DialogContent)`
  padding: 0 !important;
  background: ${colors.card};
`

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr);
  min-height: 420px;
`

export const Rail = styled.nav`
  border-right: 1px solid ${colors.line};
  background: #fafbfb;
  padding: 20px 0;
`

export const Spine = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 31px;
    top: 12px;
    bottom: 12px;
    width: 1px;
    background: ${colors.line2};
  }
`

type StepStatus = 'done' | 'now' | ''

export const SpineItem = styled.li<{ status: StepStatus }>`
  position: relative;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px 16px 8px 18px;
`

export const Dot = styled.span<{ status: StepStatus }>`
  position: relative;
  z-index: 1;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex: 0 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: monospace;
  font-size: 11px;
  background: ${p => (p.status === 'done' ? colors.ok : p.status === 'now' ? colors.signal : colors.card)};
  border: 1px solid ${p => (p.status === 'done' ? colors.ok : p.status === 'now' ? colors.signal : colors.line2)};
  color: ${p => (p.status ? '#fff' : colors.ink3)};
`

export const SLabel = styled.div<{ status: StepStatus }>`
  font-size: 12.5px;
  padding-top: 2px;
  color: ${p => (p.status === 'now' ? colors.ink : colors.ink3)};
  font-weight: ${p => (p.status === 'now' ? 500 : 400)};
`

export const SMeta = styled.span`
  display: block;
  font-family: monospace;
  font-size: 10px;
  color: ${colors.ink3};
`

export const Stage = styled.main`
  padding: 22px 26px 18px;
  display: flex;
  flex-direction: column;
`

export const StageHeading = styled.h2`
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 4px;
  color: ${colors.ink};
`

export const Lede = styled.p`
  color: ${colors.ink2};
  margin: 0 0 18px;
  font-size: 13px;
`

export const StepBody = styled.div`
  flex: 1;
`

export const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding-top: 14px;
  border-top: 1px solid ${colors.line};
`

export const Note = styled.span`
  font-size: 12px;
  color: ${colors.ink3};
`

export const Banner = styled.div<{ kind?: 'ok' | 'bad' }>`
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
  background: ${p => (p.kind === 'ok' ? colors.okBg : p.kind === 'bad' ? colors.badBg : '#f0f2f2')};
  color: ${p => (p.kind === 'ok' ? colors.ok : p.kind === 'bad' ? colors.bad : colors.ink2)};
`

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 10px;
`

export const Card = styled.div`
  background: #fafbfb;
  border: 1px solid ${colors.line};
  border-radius: 5px;
  padding: 11px 13px;

  .n {
    font-family: monospace;
    font-size: 21px;
    font-weight: 500;
  }
  .l {
    font-size: 11px;
    color: ${colors.ink3};
    font-family: monospace;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`

export const Chip = styled.span<{ kind?: 'ok' | 'bad' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: monospace;
  font-size: 11px;
  padding: 3px 9px;
  border-radius: 3px;
  background: ${p => (p.kind === 'ok' ? colors.okBg : p.kind === 'bad' ? colors.badBg : '#f0f2f2')};
  color: ${p => (p.kind === 'ok' ? colors.ok : p.kind === 'bad' ? colors.bad : colors.ink2)};
`

export const Bar = styled.div`
  height: 6px;
  background: #eceff0;
  border-radius: 3px;
  overflow: hidden;
`

export const BarFill = styled.i<{ pct: number }>`
  display: block;
  height: 100%;
  background: ${colors.signal};
  width: ${p => p.pct}%;
  transition: width 0.18s linear;
`

export const Ledger = styled.div`
  font-family: monospace;
  font-size: 11px;
  background: #0f1518;
  color: #c8d2d4;
  border-radius: 5px;
  padding: 10px 12px;
  height: 120px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const LedgerLine = styled.div<{ kind: 'g' | 'r' | 'y' | 'd' }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${p => (p.kind === 'g' ? '#6ec39b' : p.kind === 'r' ? '#e78c82' : p.kind === 'y' ? '#dcb45f' : '#6c7a7f')};
`

export const RowSplit = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
`

export const GridTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
    font-family: monospace;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${colors.ink3};
    font-weight: 400;
    padding: 0 8px 6px 0;
    border-bottom: 1px solid ${colors.line2};
  }
  td {
    padding: 8px 8px 8px 0;
    border-bottom: 1px solid ${colors.line};
    vertical-align: middle;
  }
  tr.off td {
    opacity: 0.45;
  }
`

export const IdLine = styled.span`
  font-family: monospace;
  font-size: 10.5px;
  color: ${colors.ink3};
`

export const FailRow = styled.div`
  border: 1px solid ${colors.line};
  border-left: 3px solid ${colors.bad};
  border-radius: 0 4px 4px 0;
  padding: 9px 11px;
  margin-bottom: 12px;
  font-family: monospace;
  font-size: 11px;
  color: ${colors.ink2};
`

export const FieldLabel = styled.label`
  display: block;
  font-family: monospace;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: ${colors.ink3};
  margin-bottom: 5px;
`

export const TextInput = styled.input`
  font: inherit;
  font-size: 13px;
  background: ${colors.card};
  color: ${colors.ink};
  border: 1px solid ${colors.line2};
  border-radius: 4px;
  padding: 6px 8px;

  &:focus {
    border-color: ${colors.signal};
    outline: none;
  }
  &:disabled {
    color: ${colors.ink3};
    background: #f7f8f8;
  }
`

export const PlainButton = styled.button`
  font: inherit;
  font-size: 13px;
  background: ${colors.card};
  color: ${colors.ink};
  border: 1px solid ${colors.line2};
  border-radius: 4px;
  padding: 7px 14px;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${colors.ink3};
    background: #fafbfb;
  }
  &:disabled {
    color: ${colors.ink3};
    border-color: ${colors.line};
    cursor: not-allowed;
  }
`

export const KeyButton = styled(PlainButton)`
  background: ${colors.ink};
  border-color: ${colors.ink};
  color: #fff;

  &:hover:not(:disabled) {
    background: #000;
    border-color: #000;
  }
  &:disabled {
    background: ${colors.line};
    border-color: ${colors.line};
    color: #fff;
  }
`

export const MiniButton = styled(PlainButton)`
  padding: 3px 9px;
  font-size: 12px;
  font-family: monospace;
`
